module.exports = {
	"articleTitle1": "Dean of School of Social Work to step down",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "School of Social Work",
	"articleLink1": "https://www.michigandaily.com/news/dean-school-social-work-step-down",
	"articleLink2": "https://www.michigandaily.com/news/grad-student-claims-wrongful-suspension-social-work-prepares-legal-action",
	"articleSnippet1": "Jul 1, 2015 ... Laura Lein, dean of the School of Social Work at the University, has announced \nshe will step down from her position at the end of the upcoming ...",
	"articleSnippet2": "Nov 19, 2014 ... After being charged, Roquemore said she notified the School of Social Work and \nthe field liaison in charge of her internship. “When I ended up ...",
	"totalMisc": 0,
	"articleTitle2": "Grad student claims wrongful suspension from Social Work ...",
	"address": "1080 S University Ave, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.2747,
		"lng": -83.7365
	},
	"tips": [
		{
			"text": "The ground floor has the comfiest chairs and lots of natural light.",
			"person": "Samantha Goldstein"
		}
	],
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "School of Social Work"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/schoolofsocialwork.json
// module id = 969
// module chunks = 0